import { render, staticRenderFns } from "./CaseCardSkeletonLoader.vue?vue&type=template&id=843e4e52"
import script from "./CaseCardSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./CaseCardSkeletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports